<template>
  <div class="nav-contain" :style="{ 'background-color': bgc }">
    <div class="re-back" @click="backHome" v-if="$store.state.user.showUser">
      <img :src="require('@/assets/image/icon_shouye02.png')" alt="" class="icon-home">
      <div class="text-home">首页</div>
    </div>
    <div class="input-contain">
      <el-input placeholder="请输入内容" suffix-icon="el-icon-search" v-model="input1">
      </el-input>
      <!-- <div class="draw-down">
        <div class="draw-content">
          <div class="draw-item">
            <div class="item-l"></div>
            <div class="item-r"></div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="login" v-if="$store.state.user.token.length == 0" @click="onLogin">登陆/注册</div>
    <div class="user" v-else>
      <img :src="require('@/assets/image/head_pic.png')" alt="" class="user-pic">
      <div class="user-draw">
        <div class="user-select">
          <div class="user-contain">
            <img :src="require('@/assets/image/head_pic.png')" alt="" class="head-pic">
            <div class="user-r">
              <span class="user-name">机智的弗洛里安兰斯伯爵</span>
              <img :src="require('@/assets/image/icon-ordinary-vip.png')" alt="" class="user-vip">
            </div>
          </div>
          <div class="choose">
            <div class="choose-item" v-for="choose in chooseList" :key="choose.name" @click="changeUser(choose.name)">
              <img :src="choose.src" alt="" class="item-pic">
              <span class="item-name">{{ choose.name }}</span>
            </div>
          </div>
          <div class="log-out" @click="logOut">
            <img :src="require('@/assets/image/icon_log_out.png')" alt="" class="icon-out">
            <span>退出登录</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible="$store.state.user.showLogin" :show-close="false" @close="onClose">
      <!-- <img :src="require('@/assets/image/logo_menu.png')" alt="" class="login-pic"> -->
      <h1 class="title">瑞韬剧场</h1>
      <div class="login-type">密码登录</div>
      <el-form :model="info" ref="loginForm" :rules="rules">
        <el-form-item prop="user">
          <el-input v-model="info.user" prefix-icon="el-icon-user" placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input type="password" v-model="info.pwd" prefix-icon="el-icon-lock" placeholder="密码"></el-input>
          <div class="forget-pass">忘记密码？</div>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onsubmit">提交</el-button>
          <el-checkbox v-model="checked">
            <span class="tip">我已阅读并同意</span>
            <span class="light" @click.stop="$router.push('/userAgreement')">《用户使用协议》</span>
            <span class="light" @click.stop="$router.push('/privacyPolicy')">《隐私政策》</span>
          </el-checkbox>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { removeToken } from '@/utils/auth.js'
export default {
  props: {
    bgc: {
      type: String,
      default: 'transparent'
    }
    // back: {
    //   type: Boolean,
    //   default: false
    // }
    // showLogin: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data () {
    return {
      input1: '',
      // showLogin: false,
      info: {
        user: '',
        pwd: ''
      },
      checked: true,
      chooseList: [
        { src: require('@/assets/image/icon_user_center.png'), name: '个人中心' },
        { src: require('@/assets/image/icon_set.png'), name: '账号设置' }
      ],
      rules: {
        user: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    backHome () {
      this.$router.push('/home')
    },
    // 登录弹窗
    onLogin () {
      this.$store.state.user.showLogin = true
    },
    // 关闭登录弹窗
    onClose () {
      this.$store.state.user.showLogin = false
    },
    // 账号选择
    changeUser (name) {
      if (name == '个人中心') this.$router.push()
      if (name == '账号设置') this.$router.push('/account')
    },
    // 退出登录
    logOut () {
      removeToken()
      if (this.$route.path == '/account') {
        this.$router.replace('/home')
      }
      window.location.reload()
    },
    // 登录弹窗
    onsubmit () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          if (this.checked) {
            this.$store.dispatch('user/setUserToken', '1111111')
            this.$refs.loginForm.resetFields()
            this.$store.state.user.showLogin = false
          } else {
            this.$message({
              message: '请同意协议',
              type: 'warning'
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-contain {
  width: calc(100vw - 172px);
  height: 60px;
  // background-color: transparent;
  background-color: #1A1C1F;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;

  .re-back {
    position: absolute;
    left: 40px;
    top: 21px;
    color: #666;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .icon-home {
      width: 18px;
      height: 18px;
      margin-right: 12px;
    }
  }

  .input-contain {
    width: 480px;
    height: 60px;
    // background-color: #fff;
    margin: 0 auto;
    padding: 12px 0;
    position: relative;

    &::v-deep .el-input__inner {
      background-color: #F9F9F9;
      border: none;
      border-radius: 8px;
      caret-color: #333;
      padding-left: 16px;

      &::placeholder {
        color: #999;
      }
    }

    &::v-deep .el-input__icon {
      color: #999;
      font-size: 18px;
    }

    .draw-down {
      position: absolute;
      top: 56px;
      left: 0;
      width: 480px;
      height: 468px;
      padding: 8px 0 0;

      .draw-content {
        width: 100%;
        height: 460px;
        background-color: #2E3033;
        border-radius: 12px;
        padding: 10px;

        .draw-item {
          height: 44px;
          background-color: #2E3033;
          padding: 13px 14px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #fff;

          &:hover {
            background-color: #404347;
          }

          .item-l {
            width: 17px;
            margin-right: 20px;
          }
        }
      }
    }
  }

  .login {
    width: 100px;
    height: 32px;
    background-color: #3377FF;
    border-radius: 16px;
    color: #fff;
    text-align: center;
    line-height: 32px;
    position: absolute;
    top: 14px;
    right: 70px;
    cursor: pointer;
  }

  .user {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 70px;
    cursor: pointer;

    .user-pic {
      width: 100%;
      height: 100%;
      border-radius: 20px;
    }

    .user-draw {
      width: 280px;
      height: 260px;
      // background-color: #fff;
      padding-top: 46px;
      display: none;
      position: absolute;
      top: 0px;
      right: 0px;
      z-index: 10000;

      .user-select {
        height: 216px;
        background-color: #fff;
        border-radius: 12px;
        padding: 10px;

        .user-contain {
          padding: 14px 0 20px 16px;
          display: flex;
          align-items: center;

          .head-pic {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 12px;
          }

          .user-r {
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .user-name {
              color: #333;
              font-size: 12px;
              line-height: 16px;
            }

            .user-vip {
              width: 64px;
              height: 16px;
            }
          }
        }
      }

      .choose {
        height: 68px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .choose-item {
          width: 59px;
          height: 68px;
          background-color: #999;
          border-radius: 8px;
          padding: 10px 0;
          color: rgba(255,255,255,0.6);
          // opacity: 0.6;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          &:hover {
            color: rgba(255,255,255,1);
            // color: #fff;
          }

          .item-pic {
            width: 24px;
            height: 24px;
          }

          .item-name {
            // color: #333;
            font-size: 12px;
            line-height: 16px;
          }
        }
      }

      .log-out {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #3377FF;
        font-size: 14px;
        line-height: 18px;
        border-radius: 8px;
        border: 1px solid #3377FF;
        margin-top: 8px;

        .icon-out {
          width: 18px;
          height: 18px;
          margin-right: 12px;
        }
      }
    }

    &:hover .user-draw {
      display: block;
    }
  }

  &::v-deep .el-dialog {
    width: 416px;
    background-color: #fff;
    border-radius: 12px;
    padding: 60px 48px;

    .login-pic {
      width: 180px;
      margin-bottom: 40px;
    }
    .title{
      margin-bottom: 40px;
    }
    .login-type {
      color: #333;
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 32px;
    }
  }

  &::v-deep .el-dialog__header {
    padding: 0;
  }

  &::v-deep .el-dialog__body {
    padding: 0;
  }

  &::v-deep .el-input__inner {
    background-color: #f9f9f9;
    border-radius: 8px;
    border: 1px solid #fff;
    font-size: 16px;
    padding-left: 36px;
  }

  &::v-deep .el-icon-user,
  &::v-deep .el-icon-lock {
    font-size: 24px;
    margin-right: 12px;
  }

  .forget-pass {
    color: #333;
    font-size: 14px;
    line-height: 18px;
    padding-top: 8px;
  }

  &::v-deep .el-button--danger {
    width: 100%;
    height: 40px;
    background-color: #3377FF;
    border-radius: 8px;
    border: none;
  }

  .tip {
    color: #999;
    // opacity: 0.6;
  }

  .light {
    color: #3377FF;
  }

  &::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #3377FF;
    border-color: #3377FF;
  }
}
</style>